import * as Yup from "yup";
import checkout from "./form7";

const {
  formField7: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune
  },
} = checkout;

const validation7 = Yup.object().shape({
  [endow.name]: Yup.string().required(endow.errorMsg),
  [departmentLevel.name]: Yup.string().required(departmentLevel.errorMsg),
  [subordinateToTheDepartment.name]: Yup.string().required(subordinateToTheDepartment.errorMsg),
  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [commune.name]: Yup.string().required(commune.errorMsg),
});

export default validation7;
